export default __webpack_public_path__ + "static/media/newbrochureIconNonBranded.f3e6c3c7.svg";